import { render, staticRenderFns } from "./NotSablonPicker.vue?vue&type=template&id=062c4954"
import script from "./NotSablonPicker.vue?vue&type=script&lang=ts"
export * from "./NotSablonPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports